import D from "../../../@babel/runtime/helpers/esm/extends.mjs";
import q from "../../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import * as a from "react";
import { useRef as m } from "react";
import p from "../../../rc-util/es/KeyCode.mjs";
import A from "./MultipleSelector.mjs";
import H from "./SingleSelector.mjs";
import L from "../hooks/useLock.mjs";
import { isValidateOpenKey as Q } from "../utils/keyUtil.mjs";
var U = function(e, E) {
  var t = m(null), i = m(!1), I = e.prefixCls, f = e.open, o = e.mode, S = e.showSearch, w = e.tokenWithEnter, x = e.autoClearSearchValue, s = e.onSearch, v = e.onSearchSubmit, l = e.onToggleOpen, d = e.onInputKeyDown, y = e.domRef;
  a.useImperativeHandle(E, function() {
    return {
      focus: function() {
        t.current.focus();
      },
      blur: function() {
        t.current.blur();
      }
    };
  });
  var C = L(0), g = q(C, 2), R = g[0], T = g[1], N = function(n) {
    var r = n.which;
    (r === p.UP || r === p.DOWN) && n.preventDefault(), d && d(n), r === p.ENTER && o === "tags" && !i.current && !f && (v == null || v(n.target.value)), Q(r) && l(!0);
  }, K = function() {
    T(!0);
  }, u = m(null), b = function(n) {
    s(n, !0, i.current) !== !1 && l(!0);
  }, O = function() {
    i.current = !0;
  }, k = function(n) {
    i.current = !1, o !== "combobox" && b(n.target.value);
  }, M = function(n) {
    var r = n.target.value;
    if (w && u.current && /[\r\n]/.test(u.current)) {
      var c = u.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      r = r.replace(c, u.current);
    }
    u.current = null, b(r);
  }, P = function(n) {
    var r = n.clipboardData, c = r.getData("text");
    u.current = c;
  }, V = function(n) {
    var r = n.target;
    if (r !== t.current) {
      var c = document.body.style.msTouchAction !== void 0;
      c ? setTimeout(function() {
        t.current.focus();
      }) : t.current.focus();
    }
  }, W = function(n) {
    var r = R();
    n.target !== t.current && !r && o !== "combobox" && n.preventDefault(), (o !== "combobox" && (!S || !r) || !f) && (f && x !== !1 && s("", !0, !1), l());
  }, h = {
    inputRef: t,
    onInputKeyDown: N,
    onInputMouseDown: K,
    onInputChange: M,
    onInputPaste: P,
    onInputCompositionStart: O,
    onInputCompositionEnd: k
  }, j = o === "multiple" || o === "tags" ? /* @__PURE__ */ a.createElement(A, D({}, e, h)) : /* @__PURE__ */ a.createElement(H, D({}, e, h));
  return /* @__PURE__ */ a.createElement("div", {
    ref: y,
    className: "".concat(I, "-selector"),
    onClick: V,
    onMouseDown: W
  }, j);
}, _ = /* @__PURE__ */ a.forwardRef(U);
_.displayName = "Selector";
export {
  _ as default
};
//# sourceMappingURL=index.mjs.map
